import { InfiniteData, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { Bonus } from '../../../../../../types/bonus';
import { QueryKey } from '../../../hooks/types';
import { ApiResponse } from '../../../types/api';

export const useFindBonus = () => {
	const queryClient = useQueryClient();

	return useCallback(
		(id: string) => {
			const data = queryClient.getQueriesData<InfiniteData<ApiResponse<Bonus[]>>>([QueryKey.BonusesInfinite]);

			return data.flatMap(([, cache]) => cache?.pages.flatMap((page) => page.data.result)).find((bonus) => bonus?.id === id);
		},
		[queryClient]
	);
};
